import React, { useRef } from 'react';

import { ContextValue, EditorComponentsProvider, EditorContextProvider, EditorInfoContextProvider, EditorInfoContextValue } from '../contexts';
import { DocumentComponents, DocumentNode } from '../types';
import { DocumentNodeCache, renderNode } from '../utils';
import { defaultComponents } from './defaultComponents';

export interface ViewerProps {
  document: DocumentNode;
  components?: DocumentComponents;
  disableDefaultComponents?: boolean;
  disableComponentIds?: string[];
  displayDate?: Date;
  editorInfoContext: EditorInfoContextValue;
  unitContext: ContextValue;
}

export function Viewer({
  document,
  components,
  disableDefaultComponents,
  disableComponentIds = [],
  displayDate,
  editorInfoContext,
  unitContext,
}: ViewerProps): React.ReactElement {
  const cacheRef = useRef<DocumentNodeCache>({});

  const filteredDefaultComponents = React.useMemo(() => {
    disableComponentIds.forEach((id: string) => {
      delete defaultComponents[id];
    });

    return defaultComponents;
  }, [disableComponentIds]);

  const documentComponents = {
    ...disableDefaultComponents ? {} : filteredDefaultComponents,
    ...components,
  };

  return (
    <EditorContextProvider
      value={document}
      newValue={document}
      editorType="viewer"
      components={documentComponents}
      displayDate={displayDate}
    >
      <EditorInfoContextProvider value={editorInfoContext}>
        <EditorComponentsProvider contexts={unitContext}>
          { renderNode(document, documentComponents, [], cacheRef.current) }
        </EditorComponentsProvider>
      </EditorInfoContextProvider>
    </EditorContextProvider>
  );
}
